export default function country() {
  let country_login = localStorage.getItem("country_login");
  return country_login;
}
